import { useState } from 'react';
import { trpc } from '@/trpc/client';

type AuditRow = {
  id: string;
  action: string;
  actor: { email: string };
  target: { id: string };
  createdAt: string;
};

export function AuditLog() {
  const [filter, setFilter] = useState<{ actorSub?: string; targetLineUserId?: string }>({});
  const q = trpc.audit.list.useQuery(filter);
  return (
    <div>
      <h1 className="text-xl font-bold mb-4">監査ログ</h1>
      <div className="flex gap-2 mb-4 text-sm">
        <input
          className="border rounded p-1"
          placeholder="実行者 sub で絞り込み"
          value={filter.actorSub ?? ''}
          onChange={(e) => {
            const v = e.target.value || undefined;
            setFilter((f) => ({ ...f, actorSub: v }) as typeof f);
          }}
        />
        <input
          className="border rounded p-1"
          placeholder="対象 LINE userId で絞り込み"
          value={filter.targetLineUserId ?? ''}
          onChange={(e) => {
            const v = e.target.value || undefined;
            setFilter((f) => ({ ...f, targetLineUserId: v }) as typeof f);
          }}
        />
      </div>
      {q.isLoading ? (
        <div>読み込み中…</div>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left bg-slate-100">
              <th className="p-2">時刻</th>
              <th className="p-2">操作</th>
              <th className="p-2">実行者</th>
              <th className="p-2">対象</th>
            </tr>
          </thead>
          <tbody>
            {((q.data?.items as AuditRow[]) ?? []).map((row) => (
              <tr key={row.id} className="border-b">
                <td className="p-2 font-mono">{row.createdAt}</td>
                <td className="p-2">{row.action}</td>
                <td className="p-2">{row.actor.email}</td>
                <td className="p-2 font-mono">{row.target.id}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
